<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      fixed
      app
    >
      <v-list v-if="$root.user && puedeVerMenuAdmin($root.user) > -1" nav>
        <v-list-item-group v-model="model">
          <template v-for="item in items">
            <v-list-item
              v-if="item.children === false"
              :key="$_sanitize_title(item.text)"
              exact
              :to="{ name: item.routeName }"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item>
            <v-list-group
              v-else
              :key="$_sanitize_title(item.text)"
              :group="item.group"
              :prepend-icon="item.icon"
            >
              <template v-slot:activator>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </template>
              <v-list-item
                v-for="subItem in item.children"
                v-show="!subItem.notAccesible"
                :key="$_sanitize_title(subItem.text)"
                dense
                exact
                link
                :to="{ name: subItem.routeName }"
              >
                <v-list-item-icon>
                  <v-icon v-text="subItem.icon" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="subItem.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list-item-group>
      </v-list>
      <v-list v-if="$root.user && $root.user.role === 4">
        <template v-for="(item, item_index) in items_vendedor">
          <v-list-item
            v-if="!item.children"
            @click="$router.push({ name: item.routeName })"
            :key="item_index + '_role6'"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>

          <v-list-group
            v-else
            :prepend-icon="item['icon-section']"
            v-model="item.model"
            :key="item_index + '_role6'"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(link, i) in item.children"
              :key="i + 'item.text'"
              exact
              @click="$router.push({ name: link.routeName })"
            >
              <v-list-item-icon>
                <v-icon v-text="link.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content v-text="link.text" />
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
      <template v-slot:append>
        <v-divider></v-divider>
        <v-list nav>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon v-text="'mdi-logout'"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Cerrar sesión'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="primary"
      dark
      fixed
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <span class="hidden-sm-and-down">{{ $root.name_app }}</span>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-title v-show="[1, 4, 5, 8].includes(userRole)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-chip v-on="on">
              Pedidos:
              {{
                $root.solicitudes_realizadas
                  ? `Solicitudes: ${$root.solicitudes_realizadas}`
                  : 0
              }}/ {{ $root.solicitudes_max }}</v-chip
            >
          </template>
          <span
            >Pedidos disponibles hasta el próximo corte:
            {{ $root.fecha_corte }}</span
          >
        </v-tooltip>
      </v-toolbar-title>
      <v-toolbar-title>
        <v-icon left>mdi-account</v-icon>
        <span class="hidden-sm-and-down">{{
          $root.user ? $root.user.nombre_completo : ""
        }}</span>
      </v-toolbar-title>
      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-apps</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="dialogPassword = true">
            <v-list-item-title>Cambiar contraseña</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
    <v-snackbar
      v-model="snackbar"
      rigth
      top
      :color="snackbar_config.color"
      :multi-line="snackbar_config.multi_line"
      :timeout="snackbar_config.timeout"
      :vertical="snackbar_config.mobile"
    >
      <div v-html="snackbar_config.text_content" />
      <template v-slot:action="{ attrs }">
        <v-btn dark v-bind="attrs" @click="snackbar = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialog_progress" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ dialog_progress_text }}
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPassword" max-width="600">
      <v-card>
        <v-card-title class="headline">Cambiar contraseña</v-card-title>

        <v-card-text>
          <v-text-field
            type="password"
            v-model="passwordForm.password_anterior"
            label="Contraseña anterior"
            :error-messages="passwordErrors.password_anterior"
          ></v-text-field>
          <v-text-field
            type="password"
            v-model="passwordForm.password"
            label="Nueva contraseña"
            :error-messages="passwordErrors.password"
          ></v-text-field>
          <v-text-field
            type="password"
            v-model="passwordForm.password_confirmation"
            label="Confirme nueva contraseña"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="dialogPassword = false">
            Cancelar
          </v-btn>

          <v-btn color="green darken-1" text @click="savePassword">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import EventBus from "@/EventBus";

export default {
  name: "Layout",
  props: {
    source: String,
  },
  data: () => ({
    interval: null,
    dialog: false,
    dialogPassword: false,
    passwordForm: {},
    passwordErrors: {},
    drawer: null,
    admins: [
      ["Management", "people_outline", "familias"],
      ["Settings", "settings"],
    ],
    items: [
      {
        icon: "mdi-home",
        text: "Inicio",
        routeName: "home",
        children: false,
      },
      {
        icon: "mdi-book",
        text: "Catálogos",
        model: false,
        group: "catalogos",
        children: [
          {
            icon: "mdi-account-box-multiple",
            text: "Clientes",
            routeName: "clientes",
          },
          { icon: "mdi-animation", text: "Categorías", routeName: "familias" },
          {
            icon: "mdi-package-variant-closed",
            text: "Productos",
            routeName: "productos",
          },
          {
            icon: "mdi-filter-variant",
            text: "Modificadores de productos",
            routeName: "modificadores",
          },
          //{icon: 'mdi-gift', text: 'Tipos Cupones', routeName: 'tipo_cupones'},
          {
            icon: "mdi-cash-multiple",
            text: "Tipos Precio",
            routeName: "tipo_precios",
          },
          {
            icon: "mdi-account-supervisor-circle",
            text: "Usuarios",
            routeName: "usuarios",
          },
          {
            icon: "mdi-map-search",
            text: "Zonas de Envios",
            routeName: "zona_envios",
          },
          {
            icon: "mdi-tag-multiple",
            text: "Etiquetas",
            routeName: "etiquetas",
          },
          {
            icon: "mdi-clock",
            text: "Horarios de atención",
            routeName: "horario_atencion",
            notAccesible: false,
          },
        ],
      },
      {
        icon: "mdi-book-open",
        text: "Pedidos",
        routeName: "pedidos",
        children: false,
      },
      {
        icon: "question_answer",
        text: "Aclaraciones",
        routeName: "aclaraciones",
        children: false,
      },
      {
        icon: "mdi-finance",
        text: "Reportes",
        model: false,
        group: "reportes",
        children: [
          {
            icon: "mdi-chart-line",
            text: "Ventas",
            routeName: "reporte-ventas",
          },
          {
            icon: "mdi-account-group",
            text: "Clientes",
            routeName: "reporte-clientes",
          },
          {
            icon: "mdi-account-group",
            text: "Vendedores",
            routeName: "reporte-vendedores",
          },
        ],
      },
      {
        icon: "mdi-office-building",
        text: "Más",
        group: "mas",

        model: false,
        children: [
          {
            icon: "mdi-cog",
            text: "Configuraciones",
            routeName: "configuraciones",
          },
          {
            icon: "mdi-factory",
            text: "Perfil de Empresa",
            routeName: "perfil_empresa",
          },
          {
            icon: "mdi-store",
            text: "Sucursal",
            routeName: "empresa-sucursal",
          },
          {
            icon: "mdi-text-box-multiple",
            text: "Politica de Privacidad",
            routeName: "politica_privacidad",
          },
          {
            icon: "mdi-cellphone-message",
            text: "Notificaciones",
            routeName: "notificaciones",
          },
        ],
      },
    ],
    items_vendedor: [
      { icon: "home", text: "Inicio", routeName: "home" },
      {
        icon: "mdi-book",
        text: "Catálogos",
        model: false,
        group: "catalogos",
        children: [
          /* {
            icon: "mdi-account-box-multiple",
            text: "Clientes",
            routeName: "clientes",
          }, */
          /* { icon: "mdi-animation", text: "Categorías", routeName: "familias" }, */
          {
            icon: "mdi-package-variant-closed",
            text: "Productos",
            routeName: "productos",
          },
        ],
      },
      {
        icon: "question_answer",
        text: "Aclaraciones",
        routeName: "aclaraciones",
        children: false,
      },
      { icon: "storage", text: "Pedidos", routeName: "pedidos_vendedor" },
    ],
    dialog_progress: false,
    dialog_progress_text: "Espera un momento por favor",
    model: 1,
    snackbar: false,
    snackbar_config: {
      color: "",
      multi_line: true,
      timeout: 6000,
      mobile: false,
      text_content: "",
    },
  }),
  computed: {
    userRole() {
      return this.$root.$data.user ? this.$root.user.role : 0;
    },
  },
  created() {
    EventBus.$on("tugarrafon:show-snackbar", (payload = {}) => {
      const defaultData = {
        color: "",
        multi_line: true,
        timeout: 6000,
        mobile: false,
        text_content: "",
      };

      this.snackbar_config = Object.assign(defaultData, payload);
      this.snackbar = true;
    });

    EventBus.$on(
      "tugarrafon:show-progress-dialog",
      (payload = "Espera un momento por favor ...") => {
        this.dialog_progress = true;
        this.dialog_progress_text = payload;
      }
    );

    EventBus.$on("tugarrafon:hide-progress-dialog", () => {
      this.dialog_progress = false;
      this.dialog_progress_text = "";
    });
  },
  mounted() {
    this.loadUser();
    this.listarConfiguraciones();

    this.items.map((item) => {
      if (item.group === this.$route.matched[0].meta.group) {
        item.model = true;
      }
    });

    this.loadRequests();

    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => {
      this.loadRequests();
    }, 150000);
  },
  methods: {
    loadRequests() {
      axios.get("/api/credito").then(({ data }) => {
        if (data) {
          this.$root.solicitudes_realizadas = data.solicitudes_realizadas;
          this.$root.solicitudes_max = data.solicitudes_max;
          this.$root.fecha_corte = data.fecha_corte;
        }
      });
    },
    logout() {
      this.$root.is_auth = false;
      this.$root.token = null;
      EventBus.$emit("tugarrafon:show-progress-dialog");
      axios
        .get("/api/auth/logout")
        .then(() => {
          localStorage.clear();
          delete axios.defaults.headers.common["Authorization"];
          EventBus.$emit("tugarrafon:hide-progress-dialog");
          this.$router.push({ name: "login" });
        })
        .catch(() => {
          localStorage.clear();
          delete axios.defaults.headers.common["Authorization"];
          EventBus.$emit("tugarrafon:hide-progress-dialog");
          this.$router.push({ name: "login" });
        });
    },
    loadUser() {
      axios.get("/api/auth/user").then(({ data }) => {
        this.$root.user = data;
        this.listarStatus();
      });
    },
    listarStatus() {
      axios.get("/api/pedidos/listar-estatus").then(({ data }) => {
        this.$root.estatus_all = data.data;
      });
    },
    puedeVerMenuAdmin(user) {
      const roles = [1, 2, 5, 8];
      return roles.indexOf(user.role);
    },
    savePassword() {
      this.$http
        .put("/api/app/v1/account/password", this.passwordForm)
        .then(() => {
          this.passwordForm = {};
          this.dialogPassword = false;
        })
        .catch((error) => {
          switch (error.response.status) {
            case 422:
              this.passwordErrors = error.response.data.errors;
              break;
            default:
              break;
          }
        });
    },
    listarConfiguraciones() {
      axios.get("/api/configuraciones/listar").then(({ data }) => {
        this.$root.configuraciones = data.data;
      });
    },
  },
};
</script>

<style scoped>
</style>
